import * as _ from 'lodash'

export const characteristicsUnique = (products) => {
    let characteristicsAll = []
    for (let i = 0; i < products.length; i++) {
        if (products[i].Caracteristicas !== '') {
            const characteristics = _.map(products[i].Caracteristicas.split(' | '), _.trim)
            characteristicsAll = characteristicsAll.concat(characteristics)
        }
    }
    let distinct = _.uniq(characteristicsAll);
    let distinctOrder = distinct.sort();
    return distinctOrder
}